<template>
	<modal :isOpen="isOpen">
		<template v-slot:body>
			<div class="title">Upgrade to yearly and</div>
			<div class="discount">save 58% now!</div>
			<button @click="$emit('upgrade')" class="btn btn-block btn-pink-gradient">Upgrade to yearly</button>
			<button @click="$emit('skip')" class="btn btn-block btn-color-gray">continue with QUARTERLY</button>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal'

export default {
	components: {
		Modal
	},
	props: {
		isOpen: {
			default: false
		}
	}
}
</script>

<style lang="scss" scoped>
.title {
	text-align: center;
	font-weight: bold;
	font-size: 1.4rem;
}

.discount {
	font-weight: bold;
	font-size: 2.4rem;
	color: #c67cd2;
	text-align: center;
	margin-bottom: 1.8rem;
}

.btn-color-gray {
	margin-top: 0.7rem;
}
</style>
